import "../css/main.css";

import lightLevels from "light-levels";

lightLevels();
